import React from 'react';

import { useFormikContext } from 'formik';

import Checkbox from 'components/shared/Checkbox/Checkbox';

const options = [
  {
    label: 'All',
    value: 'all'
  },
  {
    label: 'Custom',
    value: 'custom'
  }
];

const ExportColumnsCheckbox = () => {
  const { values, setFieldValue, columns } = useFormikContext();

  return (
    <div>
      <label className="m-0 text-sm font-500 text-neutral-800 first-letter:capitalize">
        Export Columns
        <span className="text-danger-400">*</span>
      </label>
      <div className="mt-2 flex flex-wrap gap-4">
        {options?.map((option, idx) => {
          const value = option?.value;
          return (
            <Checkbox
              key={idx}
              data-qa={`checkbox-${option}`}
              labelTextColor="!text-primary-900"
              isChecked={values?.export_columns?.includes(value)}
              handleClick={() => setFieldValue('export_columns', [value])}
              label={option?.label}
              rounded
            />
          );
        })}
      </div>
      {values?.export_columns?.includes('custom') && (
        <div className="mt-4 grid max-h-[200px] grid-cols-2 gap-4 overflow-y-auto">
          {columns?.map((option, idx) => {
            const value = option?.field;
            return (
              <Checkbox
                key={idx}
                data-qa={`checkbox-${option}`}
                labelTextColor="!text-primary-900"
                isChecked={values?.selected_columns?.includes(value)}
                inputClassName="!h-[20px] !w-[20px] before:!h-[18px] before:!w-[18px] after:!w-[6px] after:!h-[11px] after:!top-[3px] after:!left-[6px]"
                handleClick={() => {
                  const newValues = values?.selected_columns?.includes(value)
                    ? values?.selected_columns?.filter((val) => val !== value)
                    : [...(values?.selected_columns || []), value];

                  setFieldValue('selected_columns', newValues);
                }}
                label={option?.headerName}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ExportColumnsCheckbox;
